import { ApiCall } from '../ApiClient';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

const put = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'put' });

export interface FileInfoData {
    readonly id: string;
    readonly path: string;
    readonly type: string;
    readonly size: number;
    readonly etag: string;
    readonly metadata: Record<string, any>;
    readonly createdAt: Date;
    readonly updatedAt: Date;
}

export const filesEndpoints = {

    info: (fileId: string) => get<FileInfoData>({
        path: '/files.info',
        query: { fileId },
    }),

};
